module.exports = __webpack_public_path__ + "static/img/banner-fabric-4.4034388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/banner/en/banner-fabric-4.jpg
// module id = 518
// module chunks = 63